import { IModelBase } from "@pmis3/utils";
import { ICommonDataAttribute } from "@pmis3/data-access";
import { IVesselActivity } from "../../vessel-visit/model/vessel-activity"
import { IServiceApplication } from "../../vessel-visit";
import { ICargo } from "@pmis3/master-data-core";

export interface IVesselMovement extends IVesselActivity {
    midDraft?: number;
    foreDraft?: number;
    aftDraft?: number;
    airDraft?: number;
    loadedStatus?: number;
    cargoes?: ICargo[];
    statusId?: number;
}


export enum VesselActivityStatus {
    Pending = 269
}